import * as React from 'react'
import { IconProps } from '@app/components/Atoms/Icon'

export const PropertyIcon: React.FC<IconProps> = ({
  onClick,
  className,
  active = false,
  ...rest
}) => {
  const primaryInactive = '#0B2B45'
  const primaryActive = '#FFFFFF'
  const accent = '#62C8DB'
  const neutral = '#EBEBEF'

  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="30"
      height="30"
      viewBox="-1 -5 45 45"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(12, 5) scale(0.7)">
        <path
          d="M24.47 10.22V0.76001H1.34998V29L8.68998 5.33001L24.47 10.22Z"
          fill={active ? primaryInactive : primaryActive}
        />
        <path d="M24.34 40.64L24.29 40.79C24.29 40.79 24.32 40.69 24.34 40.64Z" fill={neutral} />
        <path
          d="M26.1 12.67L10.32 7.78L2.97998 31.45L0.97998 37.91L18.99 43.49C18.99 43.49 19.03 43.5 19.05 43.51L19.13 43.54C19.49 43.64 19.87 43.7 20.27 43.7C22.14 43.7 23.73 42.48 24.29 40.8L24.34 40.65L32.41 14.63L26.11 12.68L26.1 12.67Z"
          fill={accent}
        />
      </g>
    </svg>
  )
}

export default PropertyIcon
